import { z } from 'zod';
import { FactsSchema } from './valuation-facts';
import { UUIDSchema } from './common';
import { ReachabilityItemSchema } from './geo';
const MarketAnalysisSeriesDataShape = { time_series: FactsSchema.shape.time_series };
export const MarketAnalysisSeriesDataSchema = z.object(MarketAnalysisSeriesDataShape);
const MarketAnalysisReachabilityShape = {
    linear_distance_meters: z.number(),
    driving: ReachabilityItemSchema,
    public_transport: ReachabilityItemSchema,
    walking: ReachabilityItemSchema,
    bicycling: ReachabilityItemSchema,
};
export const MarketAnalysisReachabilitySchema = z.object(MarketAnalysisReachabilityShape);
const PointOfInterestFactSchema = FactsSchema.shape.points_of_interest.element;
const MarketAnalysisPointOfInterestShape = { ...PointOfInterestFactSchema.shape, reachability: MarketAnalysisReachabilitySchema };
export const MarketAnalysisPointOfInterestSchema = z.object(MarketAnalysisPointOfInterestShape);
const MarketAnalysisPointsOfInterestShape = {
    points: MarketAnalysisPointOfInterestSchema.array(),
};
export const MarketAnalysisPointsOfInterestSchema = z.object(MarketAnalysisPointsOfInterestShape);
// Preserve a required property whose value may be undefined, rather than an optional property.
const StatisticalDataSchema = z.union([MarketAnalysisSeriesDataSchema, z.undefined()]);
const MarketAnalysisShape = {
    statistical_data: StatisticalDataSchema,
    real_estate_data: MarketAnalysisSeriesDataSchema,
    points_of_interest: MarketAnalysisPointsOfInterestSchema,
    uuid: UUIDSchema,
    valuation_uuid: UUIDSchema.optional(),
};
export const MarketAnalysisSchema = z.object(MarketAnalysisShape);
